import { gql } from '@apollo/client';
import type { EffectiveStatusFilter } from '../../types';

/**
 * AOI 列表 (V2 左侧卡片列表)。
 *
 * <p>规则 (后端强约束):
 * <ul>
 *   <li>无 zipcode 时只能 aoiId 精确查;</li>
 *   <li>有 zipcode 才能用 aoiIdKeyword / nameKeyword / addressKeyword / latKeyword / lngKeyword / 创建时间 等模糊字段。</li>
 * </ul>
 */
export const LIST_AOI_ATTRIBUTES_V2 = gql`
  query ListAoiAttributesV2($input: BizAoiAttributeListInput!) {
    listAoiAttributes(input: $input) {
      total
      items {
        aoiId
        level
        name
        centerLatitude
        centerLongitude
        zipcode
        dataSource
        status
        createdAt
        tagCodes
      }
    }
  }
`;

export interface BizAoiAttributeListV2Input {
    zipcode?: string | null;
    /** 精确查 (无 zipcode 时的一种查法; 另一种是只给 effectiveStatus 走跨分区查)。 */
    aoiId?: number | null;
    /** 有 zipcode 时的模糊 ID。 */
    aoiIdKeyword?: string | null;
    nameKeyword?: string | null;
    /** 关联地址模糊 (后端按 address_core.unified_street_address LIKE 反查 aoi_ids)。 */
    addressKeyword?: string | null;
    latKeyword?: string | null;
    lngKeyword?: string | null;
    /** 创建时间起 (毫秒)。 */
    createdAtStart?: number | null;
    createdAtEnd?: number | null;
    typeCode?: string | null;
    /**
     * 生效状态筛选: ALL=全部 (含未生效) / UNVERIFIED / VERIFIED。
     * 不传 = 后端只返回已生效 (旧行为); 本页始终显式传, 让「全部」名副其实。
     */
    effectiveStatus?: EffectiveStatusFilter | null;
    /** 级别 (DB 口径 0 = 1 级 / 1 = 2 级); null = 不过滤。三条查询路径都可带。 */
    level?: number | null;
    /** 业务标签 code 精确筛 (隐含"有标签"); 必须与 zipcode 同用。 */
    tagCode?: string | null;
    /** 是否有业务标签: 0 / 1; 必须与 zipcode 同用。 */
    hasBizTag?: number | null;
    offset: number;
    limit: number;
}

export interface BizAoiAttributeListV2Item {
    aoiId: number;
    level: number | null;
    name: string | null;
    centerLatitude: number | null;
    centerLongitude: number | null;
    zipcode: string | null;
    dataSource: string | null;
    /** 生效状态: 1=已生效 / 0=未生效 (待人工审核); 老接口可能不带 → null 按已生效处理。 */
    status: number | null;
    createdAt: string | null;
    /** 业务标签 code 列表 (中文名查字典); 老接口不带时为 undefined */
    tagCodes?: string[] | null;
}

export interface ListAoiAttributesV2Response {
    listAoiAttributes: {
        total: number;
        items: BizAoiAttributeListV2Item[];
    };
}
